import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatToZMW, rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { FaBell, FaEye } from "react-icons/fa";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [details, setDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cashId, setCashId] = useState(0);
  const [approved, setApproved] = useState("0");
  const [comment, setComment] = useState("");
  const [bankCounts, setBankCounts] = useState({});
  const [previousBankId, setPreviousBankId] = useState(null);

  const auth = useAuth();



  const fetchTransactions = async () => {
    try {
      const response = await axios.get(rootUrl(`/getTrans/${auth.user.id}`));
      setTransactions(response.data.cash);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);
  const {allData, setAllData} = useOutletContext();
  

  const viewTransaction = async (id) => {
    setCashId(id);
    setShowModal(true);

    try {
      const response = await axios.get(rootUrl(`/getDetails/${id}`));
      const other = response.data.other;
      const actions = response.data.actions;
      const cash = transactions.find((t) => t.id === id);
      const user = allData.users?.find(a=>a.uid == cash.updatedBy)
      const preparer = `${user?.firstName} ${user?.lastName}`

      let detailsHtml = `
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr class="bg-blue-800 text-white">
              <th class="border p-2">Account</th>
              <th class="border p-2">COA</th>
              <th class="border p-2">Program</th>
              <th class="border p-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border p-2">${other[0].account}</td>
              <td class="border p-2">${other[0].chart}</td>
              <td class="border p-2">${other[0].prog}</td>
              <td class="border p-2">${cash.amount}</td>
            </tr>
          </tbody>
        </table>
        <br><br>
        <span class="my-5">Prepared by: ${preparer}</span><br>
      `;

      actions.forEach((action, index) => {
        
        const user = allData.users?.find(a=>a.uid === action.uid)
        detailsHtml += `
          <br>${["Checked By", "Authorized By", "Approved By"][index]}: 
          ${user?.firstName} ${user?.lastName} <br> 
          ${action.text}<br>
          ${action.date.substring(0, 10)}<br><br>
        `;
      });

      setDetails(detailsHtml);
    } catch (error) {
      console.error("Failed to fetch transaction details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      approved,
      commForAct: comment,
      userFor: auth.user.id,
      cashId,
    };

    try {
      const response = await axios.post(rootUrl(`/postAction`), data);
      if (response.status === 200) {
        toast.success("Successful")
        fetchTransactions();
        setShowModal(false);

      } else {
        toast.error("Failed")
      }
    } catch (error) {
      console.error("Failed to submit payment:", error);
    }
  };

  return (
    <div className="w-full">
      <div className="">
        <h4 className="text-[20px] text-slate-800 font-bold flex items-center"> <FaBell className="mr-2"/> Transactions</h4>
        <hr className="my-3" />
        <div className="container mx-auto p-4 mt-3">
          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-blue-800 text-white">
                <th className="border p-2">Sno</th>
                <th className="border p-2">Voucher</th>
                <th className="border p-2">Date</th>
                <th className="border p-2">Description</th>
                <th className="border p-2">Debit</th>
                <th className="border p-2">Credit</th>
                <th className="border p-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => (
                <tr key={transaction.id} className="text-left">
                  <td className="border p-2">{index + 1}</td>
                  <td className="border p-2">{transaction.cheque}</td>
                  <td className="border p-2">
                    {transaction.date.substring(0, 10)}
                  </td>
                  <td className="border p-2">{transaction.description}</td>
                  <td className="border p-2">
                    {formatToZMW(
                      transaction.coa_id === undefined ||
                        transaction.type === "income"
                        ? parseFloat(transaction.amount)
                        : 0
                    )}
                  </td>
                  <td className="border p-2">
                    {formatToZMW(
                      transaction.type !== undefined &&
                        transaction.type === "expense"
                        ? parseFloat(transaction.amount)
                        : 0
                    )}
                  </td>
                  <td className="border p-2">
                    <FaEye className="cursor-pointer" onClick={() => viewTransaction(transaction.id)}/>
                    
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <div
            style={{ maxHeight: "25rem" }}
            className="bg-white rounded p-8 w-1/2 mx-20 shadow-lg overflow-y-auto"
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">View More</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fa fa-times fa-lg"></i>
              </button>
            </div>
            <hr />
            <div
              className="p-4"
              dangerouslySetInnerHTML={{ __html: details }}
            ></div>
            <hr className="my-5" />
            <textarea
              placeholder="Add comment here"
              className="border p-3 m-3 text-[13px] mt-3 w-full resize-none rounded"
              rows="3"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            ></textarea>
            <select
              className="border p-3 m-3 text-[13px] mt-3 w-full rounded"
              value={approved}
              onChange={(e) => setApproved(e.target.value)}
            >
              <option value="0">Proceed</option>
              <option value="3">Approve</option>
              <option value="9">Declined</option>
            </select>
            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-700 font-semibold py-2 px-4 rounded"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mx-2"
              >
                <i className="fa fa-paper-plane"></i> Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transactions;
